import { ReactNode } from 'react';

export const TextBox = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center gap-3 rounded-3xl bg-white px-7 py-5 text-center text-sm font-bold sm:gap-5 sm:px-10 sm:py-7 sm:text-2xl ${className}`}
      style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
    >
      {children}
    </div>
  );
};
// export const TextBox = ({ children }: { children: ReactNode }) => {
//   return (
//     <div
//       className="w-full rounded-3xl bg-white px-7 py-5 text-center text-base font-bold sm:rounded-[40px] sm:px-10 sm:py-7 sm:text-2xl"
//       style={{ boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)' }}
//     >
//       {children}
//     </div>
//   );
// };
